import React, { useContext, useEffect } from 'react';
import { AppSettings } from '../../config/app-settings';

import IPTVStats from '../../components/IPTVAnalytics/IPTVStats';
import IPTVStatsTable from '../../components/IPTVAnalytics/IPTVStatsTable';
import IPTVTopPiratedVods from '../../components/IPTVAnalytics/IPTVTopPiratedVods';
import IPTVTopPiratedChannels from '../../components/IPTVAnalytics/IPTVTopPiratedChannels';
import IPTVOverallReportedStreams from '../../components/IPTVAnalytics/IPTVOverallReportedStreams';
import IPTVTopReportedStreamsMaintainers from '../../components/IPTVAnalytics/IPTVTopReportedStreamsMaintainers';
import IPTVStreamsPerCountry from '../../components/IPTVAnalytics/IPTVStreamsPerCountry';
import IPTVReportedServers from '../../components/IPTVAnalytics/IPTVReportedServers';

const IptvAnalytics = () => {
  const context = useContext(AppSettings);

  useEffect(() => {
    context.setAppHeaderNone(false);
    context.setAppSidebarNone(false);
    context.setAppContentClass('');
    context.setAppThemePanal(true);

    return () => {
      context.setAppHeaderNone(true);
      context.setAppSidebarNone(true);
      context.setAppContentClass('p-0');
      context.setAppThemePanal(false);
    };
  }, [context]);

  return (
    <main>
      <IPTVStats />
      <IPTVReportedServers />
      <IPTVStreamsPerCountry />
      <IPTVOverallReportedStreams />
      <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
        <IPTVTopPiratedVods />
        <IPTVTopPiratedChannels />
      </div>
      <IPTVTopReportedStreamsMaintainers />
      <IPTVStatsTable />
    </main>
  );
};

export default IptvAnalytics;
